module.exports = __webpack_public_path__ + "static/media/YF52_9.009b5f35.jpeg";